import { render, staticRenderFns } from "./RecoverPage.vue?vue&type=template&id=3bf6cde7&"
import script from "./RecoverPage.vue?vue&type=script&lang=js&"
export * from "./RecoverPage.vue?vue&type=script&lang=js&"
import style0 from "./RecoverPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "RecoverPage.vue"
export default component.exports